import DeliveryAssign from '../../components/deliveryCommon/DeliveryCommon';

const WaitingScreen = () => {
	return (
		<DeliveryAssign deliveryType='waiting' title='Delivery Waiting Change' />
	);
};

export default WaitingScreen;
